import React from 'react';

function LabCard({ lab }) {
  return (
    <div className="container py-4">
      <div className="card card-custom p-3">
        <div className="row g-3 align-items-center">

          {/* Left Column */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h5 className="fw-bold">{lab.name}</h5>
            <p className="text-muted mb-3">{lab.address}</p>
            <a href="/discount-card" className="btn discount-btn px-4 py-2 mb-3">Get 10% Discount</a>

            <div className="d-flex align-items-center mt-3">
              <i className="bi bi-telephone-fill phone-icon me-2"></i>
              <h6 className="mb-0 fw-bold">Call Now:
                <a href={`tel:${lab.phone}`} className="text-primary text-decoration-none">{lab.phone}</a>
              </h6>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            <iframe
              src={lab.mapUrl}
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title={`${lab.name} Map`}
            >
            </iframe>
          </div>

        </div>
      </div>
    </div>
  );
}

export default LabCard;